import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.968 12.676a.5.5 0 0 1-.936-.352C2.1 9.474 3.943 8 6.5 8c2.539 0 4.535 1.452 5.95 4.283C13.657 14.787 15.325 16 17.5 16c2.157 0 3.645-1.19 4.53-3.668a.5.5 0 0 1 .94.336C21.953 15.523 20.107 17 17.5 17c-2.588 0-4.587-1.454-5.947-4.276C10.299 10.215 8.628 9 6.5 9c-2.11 0-3.6 1.193-4.532 3.676z"
});

var SvgAdjustment = function SvgAdjustment(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgAdjustment;